import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=6b584902&scoped=true"
import script from "./SplitButton.vue?vue&type=script&lang=ts"
export * from "./SplitButton.vue?vue&type=script&lang=ts"
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=6b584902&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b584902",
  null
  
)

export default component.exports